import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';

/**
 * Full-area blocking overlay with a large spinner (same pattern as verification OTP).
 */
const BlockingSpinnerOverlay = ({ show, ariaLabel }) => {
  // Always render the overlay element so that toggling between loading and
  // idle does not cause a DOM mutation. Password managers (e.g. LastPass)
  // recompute their inline icon placement when sibling elements appear or
  // disappear, which would shift their icon to the wrong position. Keeping
  // the element mounted (and only toggling visibility) avoids that.
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 100,
        background: 'rgba(255, 255, 255, 0.72)',
        borderRadius: '4px',
        visibility: show ? 'visible' : 'hidden',
        pointerEvents: show ? 'auto' : 'none',
      }}
      role="presentation"
      aria-hidden={!show}
    >
      <Spinner
        color="primary"
        style={{ width: '2.5rem', height: '2.5rem' }}
        aria-label={ariaLabel}
      />
    </div>
  );
};

BlockingSpinnerOverlay.propTypes = {
  show: PropTypes.bool.isRequired,
  ariaLabel: PropTypes.string,
};

BlockingSpinnerOverlay.defaultProps = {
  ariaLabel: 'Loading...',
};

export default BlockingSpinnerOverlay;
